/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminDto } from '../../models/admin-dto';
import { OffsetPaginationDto } from '../../models/offset-pagination-dto';

export interface AdminControllerSearchOffset$Params {

/**
 * 페이지 크기
 */
  pageSize?: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo?: number;

/**
 * 관리자 권한
 */
  roles?: '\uAD00\uB9AC\uC790' | '\uCD5C\uACE0\uAD00\uB9AC\uC790';
}

export function adminControllerSearchOffset(http: HttpClient, rootUrl: string, params?: AdminControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<AdminDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, adminControllerSearchOffset.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('roles', params.roles, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OffsetPaginationDto & {
      'items'?: Array<AdminDto>;
      }>;
    })
  );
}

adminControllerSearchOffset.PATH = '/api/admins/search/offset';
